
export const MEETS = "Meets";
export const PET_DETAILS = "PetDetails";
export const APPOINTMENT_DETAILS = "AppointmentDetails";
export const HOME = "Home";
export const SETTINGS = "Settings";
export const PETS = "Pets";
export const PROFILE = "Profile";
export const ABOUT_US = "AboutUs";
export const PENDING = "Pending";
export const TEMPLATE = "Template";
export const TEMPLATE_DETAILS = "TemplateDetails";
export const DOCTOR_LETTER_TEMPLATES = "DoctorsLetterTemplates";
export const INBOX = "Inbox";
export const CLINIC_USERS = "ClinicUsers";
export const EMPLOYEES = "Employees";
export const USER_PERMISSIONS = "UserPage";
export const CLINIC_SERVICES = "ClinicServices";
export const WORKING_HOURS = "WorkingHours";
export const SPECIES = "Species";
export const BLOOD_DONORS = "BloodDonors";
export const DOCUMENT_CATEGORIES = "DocumentCategories";
export const INFORMATION_FIELDS = "InformationFields";
export const FEEDBACK = "Feedback";
export const CLINIC_GENERAL_SETTINGS = "ClinicGeneralSettings";
export const CLINIC_SETTINGS = "ClinicSettings";
export const CLINIC_CHANGE_LOGO = "ClinicChangeLogo";
export const CLINIC_WAREHOUSE = "ClinicWarehouse";
export const STATIONARY= "Stationary";
export const SAPS_BOX= "Box";
export const PET= "Pet";
export const AI_ASSISTANT= "AIAssistant";
export const MASTER_CLINIC_USERS="ClinicUsers";
export const SPECIES_MANAGMENT= "SpeciesManagement";
export const CLINIC_LIST = "ClinicList";
export const ADMINISTRATION="Clinics"
export const CLINIC="Clinic"
export const CLINIC_USER_DETAIL="UserDetails"
export const EMPLOYEE_EDIT = "EmployeeEdit";
export const THERAPY = "Therapy";
export const CHANGE_PASSWORD = "ChangePassword";
export const TERMS_AND_CONDITIONS = "TermsAndConditions";
